import { render, staticRenderFns } from "./mfr.vue?vue&type=template&id=5aae29de&scoped=true"
import script from "./mfr.vue?vue&type=script&lang=js"
export * from "./mfr.vue?vue&type=script&lang=js"
import style0 from "./mfr.vue?vue&type=style&index=0&id=5aae29de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae29de",
  null
  
)

export default component.exports